// src/lib/auth.js
import { getAuth, setPersistence, browserLocalPersistence,
         onAuthStateChanged, signOut,
         signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup,
         sendPasswordResetEmail, signInWithCustomToken, deleteUser,
         getAdditionalUserInfo } from 'firebase/auth';
import { app } from './firebase';

export const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence).catch(() => {});

async function publicAuthApi(path, body) {
  const response = await fetch(`/api/auth/${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload?.error || 'AUTH_REQUEST_FAILED');
    error.code = payload?.error || 'AUTH_REQUEST_FAILED';
    error.payload = payload;
    throw error;
  }
  return payload.data;
}

export const subscribeToAuth = (cb) => onAuthStateChanged(auth, cb);
export const signUpWithEmail = async (email, password) => {
  const { token } = await publicAuthApi('register', { email, password });
  return signInWithCustomToken(auth, token);
};
export const signInWithEmail = (email, password) => signInWithEmailAndPassword(auth, email, password);

const google = new GoogleAuthProvider();
google.setCustomParameters({ prompt: 'select_account' });
export const signInWithGoogle = async ({ allowCreate = false } = {}) => {
  const result = await signInWithPopup(auth, google);
  const isNewUser = Boolean(getAdditionalUserInfo(result)?.isNewUser);
  if (isNewUser && !allowCreate) {
    await deleteUser(result.user);
    const error = new Error('No existe una cuenta para ese correo.');
    error.code = 'auth/no-account-for-google';
    throw error;
  }
  return result;
};
export const getAccountMethods = (email) => publicAuthApi('account-methods', { email });

export const resetPassword = (email) => sendPasswordResetEmail(auth, email);

export const logOut = () => signOut(auth);
